export function formatRupiah(value) {
    const formatter = new Intl.NumberFormat('id-ID', {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    });
    return `Rp${formatter.format(value)}`;
}